import React, { useState, useRef } from 'react';
import { UploadCloud } from 'lucide-react';

const DragDropImageUpload = ({
  value,
  onChange,
  onUpload,
  disabled,
  placeholder = "Or enter image URL",
  buttonText = "Upload Image",
  id = "image-upload",
  multiple = false
}) => {
  const [isDragActive, setIsDragActive] = useState(false);
  const inputRef = useRef(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setIsDragActive(true);
    } else if (e.type === "dragleave") {
      setIsDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      if (multiple) {
        onUpload(Array.from(e.dataTransfer.files));
      } else {
        onUpload(e.dataTransfer.files[0]);
      }
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files.length > 0) {
      if (multiple) {
        onUpload(Array.from(e.target.files));
      } else {
        onUpload(e.target.files[0]);
      }
      // Reset input value so same file can be uploaded again if needed
      e.target.value = null;
    }
  };

  return (
    <div
      className={`border-2 border-dashed p-4 flex flex-col sm:flex-row gap-3 items-center transition-all duration-300 ${isDragActive ? 'border-[#FF9900] bg-[#FF9900]/10 scale-[1.02]' : 'border-[#27272A] bg-[#121212]'}`}
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
      onDrop={handleDrop}
    >
      <div className="flex-1 w-full">
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full bg-[#1A1A1A] border border-[#27272A] text-[#F3F4F6] px-4 py-3 focus:border-[#FF9900] focus:outline-none"
          placeholder={placeholder}
          data-testid={`${id}-text-input`}
        />
      </div>
      <div className="relative w-full sm:w-auto">
        <input
          ref={inputRef}
          type="file"
          accept="image/jpeg,image/jpg,image/png,image/webp,image/gif,image/svg+xml,application/pdf"
          multiple={multiple}
          onChange={handleChange}
          className="hidden"
          disabled={disabled}
          id={id}
        />
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={disabled}
          className={`w-full sm:w-auto flex items-center justify-center gap-2 px-6 py-3 bg-[#FF9900] text-black font-bold uppercase transition-colors ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:bg-white'}`}
        >
          <UploadCloud className="w-5 h-5" />
          {disabled ? 'Uploading...' : buttonText}
        </button>
      </div>
    </div>
  );
};

export default DragDropImageUpload;
